<div class="login-required-container">
  <div class="non-authenticated-section">
    <span class="auth-req">{{ 'MyProfile.NON_AUTH_TITLE' | translate }}</span>
    <span class="auth-msg">{{ 'MyProfile.NON_AUTH_MSG' | translate }}</span>
    <button class="login-btn" (click)="login()">{{ 'MyProfile.NON_AUTH_BTN' | translate }}</button>
  </div>
</div>
